import * as React from 'react';
import {BaseHistory} from './history/base';
import {HistoryContext} from './history-context';
import {browserHistory} from 'src/reroutes/browser-history';


export function RouterProvider({
  history,
  children,
}: {
  history: BaseHistory;
  children: React.ReactNode;
}) {
  const [_, setState] = React.useState<any>();

  React.useEffect(
    () =>
      history.addListener(() => {
        console.log('location change event');
        setState({});
      }),
    [history],
  );

  const contextValue = React.useMemo(
    () => ({history}),
    // @ts-expect-error - TS2339 - Property 'href' does not exist on type '() => RerouterLocation'.
    [history.location.href],
  );

  // @ts-expect-error - TS2339 - Property 'href' does not exist on type '() => RerouterLocation'.
  console.log('provider', history.location.href);

  return (
    <HistoryContext.Provider value={contextValue}>
      {children}
    </HistoryContext.Provider>
  );
}
